module.exports = __webpack_public_path__ + "static/media/ru.ab61f31e.svg";